import styled from '@emotion/styled';

import { COLOR_BORDER, COLOR_SURFACE, RADIUS_XL, SHADOW_CARD } from './utils/variables';

export const Card = styled.div`
  background: ${COLOR_SURFACE};
  border: 1px solid ${COLOR_BORDER};
  border-radius: ${RADIUS_XL};
  overflow: hidden;
  box-shadow: ${SHADOW_CARD};
`;
